

























import Vue, { VNode } from 'vue';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwDropMenu, DropMenuItem } from '@libs-uuif/shared/sw-drop-menu';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
// import { utilService } from '@libs-uuif/shared/util-service';

const cssPrefix = 'context-menu';

/**
 * Events:
 * @event select `(itemId: string)`
 * @event request-toggle
 */
export default Vue.extend({
  functional: true,
  props: {
    menuItems: { type: Array, default: (): DropMenuItem[] => { return []; } },
    opened: { type: Boolean, required: true },
    cellKey: { type: String, required: true },
  },
  /* tslint:disable-next-line */
  render(h, context) {

    function onClickTrigger(event?: MouseEvent) {
      const eventHandle = context.listeners['request-toggle'];
      if (typeof eventHandle !== 'function') { return; }
      if (event) { event.stopPropagation(); }
      eventHandle(event);
    }

    function onRequestClose() {
      context.props.opened = !context.props.opened;
    }

    function onSelect(itemId: string) {
      const eventHandle = context.listeners['select'];
      if (typeof eventHandle !== 'function') { return; }
      eventHandle(itemId);
    }

    const rootNode: VNode = (
      <SwDropMenu class={[`${cssPrefix}`, { [`${cssPrefix}--opened`]: context.props.opened }]}
        opened={context.props.opened}
        items={context.props.menuItems}
        on-select={onSelect}
        on-request-close={onRequestClose}
        withArrow={true}
        align={'left'}
      >
        <div class={[`${cssPrefix}__wrapper`]}
          on-click={onClickTrigger}
        >
          <SwIconButton
            as-block icon="more" size={17}
            no-border
            v-tooltip={{ compact: true, content: 'More Actions', placement: 'top' }}
          />
        </div>
      </SwDropMenu>
    ) as VNode;
    return rootNode;
  },
}) as typeof SwExtendedVue;
